// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3mgUC","empty":"ModalGraph_empty__8SkKJ"};